var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseForm',{attrs:{"anchor-name":_vm.anchorName,"locale":_vm.locale,"form":_vm.form,"background-color":_vm.payload.st_background_color,"show-design-shield-option":_vm.payload.st_show_design_shield}})
}
var staticRenderFns = []

export { render, staticRenderFns }